import React, { ReactNode } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

interface InfoFieldItemProps {
  label: string;
  labelWidth?: string | number;
  labelAlign?: 'left' | 'right' | 'center';
  children: ReactNode;
  sx?: SxProps<Theme>;
  labelSx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;
}

/**
 * ラベルと値のペアを表示するための情報フィールドコンポーネント
 */
const InfoFieldItem: React.FC<InfoFieldItemProps> = ({
  label,
  labelWidth = '160px',
  labelAlign = 'right',
  children,
  sx,
  labelSx,
  contentSx
}) => {
  return (
    <Box sx={{display: 'flex', alignItems: 'flex-start', ...sx}}>
      <Box
        sx={{
          width: labelWidth,
          textAlign: labelAlign,
          mr: 2,
          ...labelSx
        }}
      >
        <Typography component="span" sx={{color: 'text.secondary'}}>
          {label}
        </Typography>
      </Box>
      <Box sx={{flex: 1, ...contentSx}}>
        {children}
      </Box>
    </Box>
  );
};
export default InfoFieldItem;
